<template>
    <kgr-loading
        v-if="loading"
        :inline="true"
    />
    <select
        v-else
        :id="id"
        v-model="selected"
        class="kgr-select"
        :disabled="disabled"
        @change="update()"
    >
        <option
            :value="null"
            class="kgr-select__option"
        >
            {{ $t('pleaseChooseAnOption') }}
        </option>
        <option
            v-for="option in options"
            :key="option.id"
            :value="option"
            class="kgr-select__option"
        >
            {{ option.value }}
        </option>
    </select>
</template>

<script>
import ClubRepository from '../../js/repository/ClubRepository';
import Loading from '../common/Loading.vue';
import ParameterValue from '../../js/dto/ParameterValue';

export default {
    components: {
        'kgr-loading': Loading,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        value: {
            type: ParameterValue,
            required: false,
            default: null,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            options: [],
            loading: true,
            selected: null,
        }
    },
    computed: {
        id() {
            return `kgr-academic-title-select-club-${this.clubId}`
        },
    },
    created() {
        if (this.value) {
            this.selected = this.value;
        }

        ClubRepository.findAcademicTitles(this.clubId)
            .then(
                academicTitles => {
                    this.options = academicTitles;
                    this.loading = false;
                })
            .catch(() => this.$notify.error('error.loadingData'));
    },
    methods: {
        update() {
            const value = this.selected;
            const selection = '' === value ? null : value
            this.$emit('input', selection);
            this.$nextTick(() => {
                this.$emit('post-input', selection);
            });
        },
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
